import { Outlet } from "react-router-dom";
import { Header } from "./Header.js";
import { Footer } from "./Footer.js";

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
